import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from "moment";

import Icon from "../../../../icon";
import { DATE_FORMATS_MESSAGE } from "../../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../../../utils/constant.utils";
import Translation from "../../../translation/translation.component";
import { adminSettingActions } from "../../../../../store/admin-setting.reducer";

class DateFormat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConModal: false,
            showOption: false,
            selectedDateFormatId: 0
        };
        this.dateFormatRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (this.state.showOption && this.dateFormatRef.current && !this.dateFormatRef.current.contains(event.target)) {
            this.setState({ showOption: false });
        }
    };

    handleShowModal = (key) => {
        this.setState({ showConModal: true, selectedDateFormatId: key });
        this.props.handleModal(true);
    }

    handleShowOption() {
        this.setState(prev => ({ showOption: !prev.showOption }));
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            await this.props.saveDateFormat(this.state.selectedDateFormatId);
            this.setState(prev => ({
                showConModal: !prev.showConModal,
            }));
        } else {
            this.setState({ showConModal: false });
        }
        this.setState({ selectedDateFormatId: 0 });
        this.props.handleModal(false);
    }

    render() {
        const { activeDateFormat, dateFormatOptions } = this.props.adminSetting;
        return (
            <>
            <ConfirmationNotificationModal
                    show={this.state.showConModal}
                    message={
                        <>
                            {DATE_FORMATS_MESSAGE.Message}
                            <br /> <br />
                            {DATE_FORMATS_MESSAGE.SeconeMessage}
                        </>
                    }
                    title="Default Date Format"
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal confirm-modal-container'}
                    discardBtn={true}
            />
            <div ref={this.dateFormatRef} className="userprofile-references custom-dropdown-button-container">
                <p className="title">
                    {<Translation translationKey="administration_setting" />}
                </p>
                <div onClick={this.handleShowOption.bind(this)}>
                    <Icon
                        customClassName="calendar-days"
                        name="calendar-days"
                        labelValue={<Translation translationKey="date_format" />}
                        size="19px"
                        containerClass="icon-container mb-0"
                    />
                </div>
                {
                    this.state.showOption &&
                    <div className="custom-dropdown-list">
                        <div>
                            <p className="title mb-2">
                                 {<Translation translationKey="select_date_format" />}
                            </p>
                        </div>
                        <table>
                            <tbody>
                                {dateFormatOptions.map((item, index) => (
                                    <tr key={index} onClick={() => this.handleShowModal(item.Key)}>
                                        <td className={activeDateFormat.Name == item.Value ? "font-weight-bold " : ""}>{item.Value}</td>
                                        <td className={(activeDateFormat.Name == item.Value ? "font-weight-bold " : "") + "fs-12 text-uppercase"}>({moment().format(item.Value)})</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }                
            </div>
            </>
        );
    }
}

export default connect(
    state => {
        const { adminSetting } = state;

        return {
            adminSetting
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, adminSettingActions),
        dispatch
    )
)(DateFormat);